import { FaDiscord, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SOCIALS_CONFIG } from "../../../config/socials_config";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { useSubscriptionsModal } from "../../../providers/SubscriptionsModalProvider";
import { typography, colors, spacing, responsive, components } from "../../../design/tokens";

export function WelcomeFooter() {
  const isCompactView = useIsCompactView();
  const { open: openSubscriptionsModal } = useSubscriptionsModal();

  return (
    <footer className="w-full text-white z-10 relative" style={{ backgroundColor: '#0B0B0B' }}>
      {/* Gradient fade from page background to footer */}
      <div
        className="absolute top-0 left-0 right-0 pointer-events-none"
        style={{
          height: '100px',
          background: 'linear-gradient(to bottom, rgba(23, 25, 28, 1) 0%, rgba(11, 11, 11, 1) 100%)',
        }}
      />
      <div className={`${responsive("px-8 pt-16 pb-10", "px-8 pt-20 pb-12", isCompactView)} ${spacing.maxWidth.content} mx-auto relative z-10`}>
        {/* Desktop: 3 columns, Mobile: 2 columns with Connect on second row */}
        <div className={`grid ${responsive("grid-cols-2 gap-x-8 gap-y-10", "grid-cols-3 gap-16", isCompactView)} mb-16`}>
          {/* Column 1: Product */}
          <div className="space-y-5">
            <h3 className={`${typography.size.xs} ${typography.weight.medium} ${typography.transform.uppercase} ${typography.tracking.wider}`} style={{ color: colors.hex.footerHeader }}>
              Product
            </h3>
            <div className={`${spacing.gap.sm} ${typography.size.base} flex flex-col items-start`}>
              <button
                id="home-pricing-footer"
                onClick={openSubscriptionsModal}
                className={components.button.footer}
                style={{ color: colors.hex.footerLink }}
              >
                Pricing
              </button>
              <a
                href="/faq"
                className={components.button.footer}
                style={{ color: colors.hex.footerLink }}
              >
                FAQ
              </a>
              <a
                href="/blog"
                className={components.button.footer}
                style={{ color: colors.hex.footerLink }}
              >
                Blog
              </a>
            </div>
          </div>

          {/* Column 2: Legal */}
          <div className="space-y-5">
            <h3 className={`${typography.size.xs} ${typography.weight.medium} ${typography.transform.uppercase} ${typography.tracking.wider}`} style={{ color: colors.hex.footerHeader }}>
              Legal
            </h3>
            <div className={`${spacing.gap.sm} ${typography.size.base} flex flex-col items-start`}>
              <a
                href="/privacy-policy"
                className={components.button.footer}
                style={{ color: colors.hex.footerLink }}
              >
                Privacy Policy
              </a>
              <a
                href="/terms-of-service"
                className={components.button.footer}
                style={{ color: colors.hex.footerLink }}
              >
                Terms of Service
              </a>
            </div>
          </div>

          {/* Column 3: Connect */}
          <div className="space-y-5">
            <h3 className={`${typography.size.xs} ${typography.weight.medium} ${typography.transform.uppercase} ${typography.tracking.wider}`} style={{ color: colors.hex.footerHeader }}>
              Connect
            </h3>
            <div className={`flex items-center ${spacing.gap.sm}`}>
              <a
                href="https://discord.gg/Qkn5JfZMDN"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-all duration-300
                  border border-transparent hover:border-white
                  p-2 rounded"
                style={{ color: colors.hex.footerLink }}
              >
                <FaDiscord className="w-7 h-7" />
              </a>
              <a
                href={SOCIALS_CONFIG.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-all duration-300
                  border border-transparent hover:border-white
                  p-2 rounded"
                style={{ color: colors.hex.footerLink }}
              >
                <FaLinkedin className="w-7 h-7" />
              </a>
              <a
                href={SOCIALS_CONFIG.x}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-all duration-300
                  border border-transparent hover:border-white
                  p-2 rounded"
                style={{ color: colors.hex.footerLink }}
              >
                <FaXTwitter className="w-7 h-7" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
